import React from 'react';
import type { DiaryItem } from '../models/diary';
import MealItemEditForm from './MealItemEditForm';
import FitnessItemEditForm from './FitnessItemEditForm';
import SupplementItemEditForm from './SupplementItemEditForm';

interface DiaryItemEditModalProps {
  open: boolean;
  item: DiaryItem | null;
  onChange: (field: string, value: any) => void;
  onSave: () => void;
  onCancel: () => void;
}

const DiaryItemEditModal: React.FC<DiaryItemEditModalProps> = ({ open, item, onChange, onSave, onCancel }) => {
  if (!open || !item) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, maxWidth: 420, boxShadow: '0 4px 32px rgba(0,0,0,0.13)' }}>
        <h2 style={{ marginTop: 0, marginBottom: 18 }}>Editar {item.type === 'MealItem' ? 'Comida' : item.type === 'FitnessItem' ? 'Ejercicio' : 'Suplemento'}</h2>
        {item.type === 'MealItem' && <MealItemEditForm item={item} onChange={onChange} />}
        {item.type === 'FitnessItem' && <FitnessItemEditForm item={item} onChange={onChange} />}
        {item.type === 'SupplementItem' && <SupplementItemEditForm item={item} onChange={onChange} />}
        <div style={{ display: 'flex', gap: 12, marginTop: 24, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{ background: '#eee', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 600, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={onSave} style={{ background: '#38b2ac', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 600, cursor: 'pointer' }}>Guardar</button>
        </div>
      </div>
    </div>
  );
};

export default DiaryItemEditModal; 